export const SET_TERMS_AND_CONDITIONS = 'termsAcceptanceComponent.setTermsAndConditions'
export const SET_PRIVACY_POLICY = 'termsAcceptanceComponent.setPrivacyPolicy'
export const SET_IS_LOADING_DATA = 'termsAcceptanceComponent.setIsLoadingData'
export const RESET = 'termsAcceptanceComponent.reset'

export function setTermsAndConditions(payload: string) {
  return {
    type: SET_TERMS_AND_CONDITIONS,
    payload
  } as const
}

export function setPrivacyPolicy(payload: string) {
  return {
    type: SET_PRIVACY_POLICY,
    payload
  } as const
}

export function setIsLoadingData(payload: boolean) {
  return {
    type: SET_IS_LOADING_DATA,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type TermsAcceptanceAction = ReturnType<
  typeof setTermsAndConditions | typeof setPrivacyPolicy | typeof setIsLoadingData | typeof reset
>
